const commonRoute = [
    {
        path: "/404",
        name: "404",
        component: ()=>import("@/views/common/404.vue"),
    }
]

export default commonRoute
